import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxLoadingModule } from 'ngx-loading';
import { NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { AgmCoreModule } from '@agm/core';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns'; 
import { MyDatePickerModule } from 'mydatepicker';
import { ToastrModule } from 'ngx-toastr';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { LocalStorageService } from 'ngx-store';
import { AppSettings } from './app.settings';
import { environment } from 'src/environments/environment';

//Module
import { SharedModule } from './shared/shared.module';
import { PipesModule } from './theme/pipes/pipes.module';
import { FileUploaderModule } from './pages/control/file-uploader/file-uploader.module';
import { ImageUploaderModule } from './pages/control/image-uploader/image-uploader.module';
import { MultipleImageUploaderModule } from './pages/control/multiple-image-uploader/multiple-image-uploader.module';
import { AppRoutingModule } from './app.routing';
import { CoreModule } from 'src/lib/core/core.module';
import { AngularFireModule } from '@angular/fire';
import { SuperAdminModule } from './pages/superadmin/superadmin.module';

//Component
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { HeaderComponent } from './theme/components/header/header.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import { SidebarComponent } from './theme/components/sidebar/sidebar.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';
import { BackTopComponent } from './theme/components/back-top/back-top.component';
import { FullScreenComponent } from './theme/components/fullscreen/fullscreen.component';
import { ApplicationsComponent } from './theme/components/applications/applications.component';
import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { FlagsMenuComponent } from './theme/components/flags-menu/flags-menu.component';
import { SideChatComponent } from './theme/components/side-chat/side-chat.component';
import { FavoritesComponent } from './theme/components/favorites/favorites.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { TasknotificationsComponent } from './pages/tasknotifications/tasknotifications.component';
import { AdvancedComponent } from './pages/advanced/advanced.component';
import { TasksComponent } from './pages/tasks/tasks.component';
import { ComplianceComponent } from './pages/compliance/compliance.component';
import { DriverFitnessTestsComponent } from './pages/compliance/driverfitnesstests/driverfitnesstests.component';
import { SummaryComponent } from './pages/compliance/summary/summary.component';
import { VehicleChecksComponent } from './pages/compliance/vehiclechecks/vehiclechecks.component';
import { MessagingComponent } from './pages/messaging/messaging.component';
// import { EmployeeRegistrationsComponent } from './pages/registrations/employee-registrations/employee-registrations.component';
// import { EmployeedetailsComponent } from './pages/registrations/employee-registrations/employeedetails/employeedetails.component';
import { DispatchModule } from './pages/dispatch/dispatch.module';
import { BookingsModule } from './pages/bookings/bookings.module';
import { FuelModule } from './pages/fuel/fuel.module';
import { QualityAssuranceReportComponent} from './pages/qar/qar.component';
import { JobNotificationsComponent } from './pages/jobnotifications/jobnotifications.component';
import { MassmanagementComponent } from './pages/compliance/massmanagement/massmanagement.component';
import { ComponentsSettingsService } from './services/components_settings.service';

@NgModule({  
  imports: [
    CoreModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    NgbModule,
    MultiselectDropdownModule,
    AngularEditorModule,
    NgxDatatableModule,
    ImageUploaderModule,
    FileUploaderModule,
    NgxChartsModule,
    MultipleImageUploaderModule,
    MyDatePickerModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAO7Mg2Cs1qzo_3jkKkZAKY6jtwIlm41-I'
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    ToastrModule.forRoot(), 
    PipesModule,
    AppRoutingModule,
    NgxPaginationModule,
    NgxLoadingModule.forRoot({
      backdropBackgroundColour: 'rgba(240,240,240,0.5)',
      backdropBorderRadius: '10px',
      primaryColour: '#aaa', 
      secondaryColour: '#aaa', 
      tertiaryColour: '#aaa'
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    SharedModule,
    DispatchModule,
    BookingsModule, 
    FuelModule,
    SuperAdminModule
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    BreadcrumbComponent,
    BackTopComponent,
    FullScreenComponent,
    ApplicationsComponent,
    MessagesComponent,
    UserMenuComponent,
    FlagsMenuComponent,
    SideChatComponent,
    FavoritesComponent,
    BlankComponent,
    SearchComponent,
    NotFoundComponent,
    TasknotificationsComponent,
    AdvancedComponent,
    TasksComponent,
    ComplianceComponent,
    QualityAssuranceReportComponent,
    DriverFitnessTestsComponent,
    SummaryComponent,
    VehicleChecksComponent,
    MessagingComponent,
    // EmployeeRegistrationsComponent,
    // EmployeedetailsComponent,
    JobNotificationsComponent,
    MassmanagementComponent,
  ],
  providers: [ 
    AppSettings,
    LocalStorageService,
    ComponentsSettingsService,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { } 